@if (showOverlay()) {
  <div class="background-image full-z-index">
    <div class="items-container">
      <div class="mask-logo">
        <img src="../../../assets/images/logos/bubble-navy-3-color.svg" alt="Scoot Logo" />
      </div>
      <div class="overlay-text">
        {{ overlayText() }}
      </div>

      <div class="loading-bar-container">
        <mat-progress-bar class="loading-bar" mode="indeterminate"></mat-progress-bar>
      </div>
    </div>
  </div>
}

<div class="orientation-page" style="--background-color: {{ themeBackgroundColor() }}">
  <div class="interactive-box">
    <div class="orientation-box orientation-div" style="--div-color: {{ backgroundDivColor() }}">
      <div class="orientation-title">Orientation</div>
      <div class="orientation-step">{{ stepText() }}</div>
    </div>
    <div class="skip-div orientation-div" style="--div-color: {{ backgroundDivColor() }}" (click)="skipStep(true)">
      <div class="skip-text">Skip</div>
      @if (stepProgress() > 0) {
        <div class="step-progress-bar">
          <mat-progress-bar mode="determinate" [value]="stepProgress()"></mat-progress-bar>
        </div>
      }
    </div>
  </div>

  <div class="orientation-info" style="--div-color: {{ backgroundDivColor() }}">
    <div class="step-description">
      {{ stepDescription() }}
    </div>
    <div class="next-div" (click)="nextStep(true)">
      <div class="step-text">Next <mat-icon>arrow_forward</mat-icon></div>
      @if (pathStepProgress() > 0) {
        <div class="step-progress-bar">
          <mat-progress-bar mode="determinate" [value]="pathStepProgress()"></mat-progress-bar>
        </div>
      }
    </div>
  </div>

  @if (showMockBadge()) {
    <div class="mock-badge">
      <img src="assets/images/onboarding-experience/badge.svg" alt="Badging Info Mock User" />
    </div>
  }

  <div class="orientation-content">
    <app-pixi-onboarding-experience
      [user]="user()"
      [social]="social()"
      [showGroupingGif]="showGroupingGif()"
      [showStageMagicGif]="showStageMagicGif()"
      [step]="mockVideoStep()"
      [toggleMiniMap]="toggleMiniMap()"
    ></app-pixi-onboarding-experience>
  </div>

  <!-- Presentation Toolbar -->
  <app-presentation-toolbar
    [social]="social()"
    [isPerforming]="false"
    [showZoomControls]="false"
    [isLoadingPresentation]="false"
    [isOrientationExperience]="true"
    class="position-presentation-toolbar"
    nativeCursor
  ></app-presentation-toolbar>

  @if (showBadge()) {
    <app-badging-info
      [showRoomActionIcons]="true"
      [user]="user()"
      [isOnboardingExperience]="true"
      [isPreviewCard]="true"
      [customStyle]="true"
      [previewBadgeInfo]="{
        userName: formatUserName(userInfo()?.firstName, userInfo()?.lastName),
        companyName: userInfo()?.companyName,
        userTitle: userInfo()?.title,
        aboutMe: userInfo()?.aboutMe,
      }"
    ></app-badging-info>
  }
</div>
